/**
 * @owner @Appboy/messaging-experience
 */
import sharedConstants from "@lib/shared_constants";

/** Fallback defaults mirrored from `SharedConstants::MESSAGE_PRIORITIZATION[:LIMITS]` until feature limits resolve. */
export const messagePrioritizationDefaultScheduledActiveOptInLimit =
  sharedConstants.MESSAGE_PRIORITIZATION.LIMITS.SCHEDULED;

/** Fallback defaults mirrored from `SharedConstants::MESSAGE_PRIORITIZATION[:LIMITS]` until feature limits resolve. */
export const messagePrioritizationDefaultTriggeredActiveOptInLimit =
  sharedConstants.MESSAGE_PRIORITIZATION.LIMITS.TRIGGERED;

/** Fallback defaults mirrored from `SharedConstants::MESSAGE_PRIORITIZATION[:LIMITS]` until feature limits resolve. */
export const messagePrioritizationDefaultCategoriesLimit = sharedConstants.MESSAGE_PRIORITIZATION.LIMITS.CATEGORIES;

/** Fallback defaults mirrored from `SharedConstants::MESSAGE_PRIORITIZATION[:LIMITS]` until feature limits resolve. */
export const messagePrioritizationDefaultRulesLimit = sharedConstants.MESSAGE_PRIORITIZATION.LIMITS.RULES;

/** Fallback default retry window cap in days. Mirrors `DEFAULT_RETRY_WINDOW_DAYS_LIMIT`. */
export const messagePrioritizationDefaultRetryWindowDays =
  sharedConstants.MESSAGE_PRIORITIZATION.LIMITS.RETRY_WINDOW_DAYS;
